import StudentAdmission from 'src/view-controller/Student/Admission/StudentAdmission'

export const MENU_ICONS = {
  dashboard: 'https://img.icons8.com/color/48/dashboard-layout.png',
  onlinePayment: 'https://img.icons8.com/color/48/card-in-use.png',
  onlineClass:
    'https://img.icons8.com/external-nawicon-flat-nawicon/64/external-online-class-online-learning-nawicon-flat-nawicon.png',
  students: 'https://img.icons8.com/fluency/48/students.png',
  admission: 'https://img.icons8.com/fluency/48/student-female.png',
  feeManagement: 'https://img.icons8.com/fluency/48/cash--v1.png',
  settings: 'https://img.icons8.com/fluency/48/support.png',
  admitCard: 'https://img.icons8.com/fluency/48/identification-documents.png',
  studentPromotion: 'https://img.icons8.com/fluency/48/student-exchange.png',
  submenu: 'https://img.icons8.com/fluency/48/right.png',
  report: 'https://img.icons8.com/color-glass/48/graph-report.png',
  staffManagement: 'https://img.icons8.com/fluency/48/conference-background-selected.png',
  staffRoleManagement: 'https://img.icons8.com/color-glass/48/management.png',
  paymentProcessing: 'https://img.icons8.com/pulsar-gradient/48/payment-processed.png',
  certificates: 'https://img.icons8.com/bubbles/100/certificate.png',
  timeTable: 'https://img.icons8.com/3d-fluency/94/timetable.png',
  masterSetting: 'https://img.icons8.com/fluency/48/grand-master-key.png',
  subjectSettings: 'https://img.icons8.com/color/48/book-shelf.png',
  reportCard: 'https://img.icons8.com/scribby/50/report-card.png',
  templateManagement: 'https://img.icons8.com/color-glass/48/template.png',
  reportAnalysis: 'https://img.icons8.com/color/48/business-report.png',
  generateReport: 'https://img.icons8.com/pulsar-gradient/48/statistics-report.png',
  permission:
    'https://img.icons8.com/external-filled-outline-wichaiwi/48/external-Permission-business-filled-outline-wichaiwi.png',
  marks: 'https://img.icons8.com/fluency/48/exam.png',
  multipleReports:
    'https://img.icons8.com/external-edtim-lineal-color-edtim/50/external-Documentation-business-edtim-lineal-color-edtim.png',
  schoolBus:
    'https://img.icons8.com/external-those-icons-flat-those-icons/48/external-School-Bus-transportation-and-vehicles-those-icons-flat-those-icons.png',
  scholar: 'https://img.icons8.com/fluency/48/graduation-cap.png',
  marksEnrty: 'https://img.icons8.com/ios/50/test-failed.png',
  holistic: 'https://img.icons8.com/color/48/balance.png',
  assignment: 'https://img.icons8.com/color/48/homework.png',
  holiday: 'https://img.icons8.com/emoji/48/camping.png',
  syllabus: 'https://img.icons8.com/color/48/curriculum.png',
  petty: 'https://img.icons8.com/color-glass/96/pay.png',
  pettySettings: 'https://img.icons8.com/ios-filled/50/crypto-trading-options.png',
  message: 'https://img.icons8.com/fluency/48/envelope-dots.png',
  feeSetting:
    'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/external-charge-online-money-service-flaticons-lineal-color-flat-icons.png',
  gps: 'https://img.icons8.com/fluency/48/worldwide-location.png',
  communication: 'https://img.icons8.com/color/48/people-working-together.png',
  // idcard: 'https://img.icons8.com/fluency/96/badge--v1.png',
  idcard: 'https://img.icons8.com/fluency/48/id-verified.png',
  admissionRegisteration: 'https://img.icons8.com/stickers/100/admission.png',
  eContent:
    'https://img.icons8.com/external-vectorslab-flat-vectorslab/53/external-digital-book-education-vectorslab-flat-vectorslab.png',
}
export const OTHER_ICONS = {
  showPassword: 'https://img.icons8.com/fluency-systems-filled/48/visible.png',
  hidePassword: 'https://img.icons8.com/fluency-systems-filled/50/hide.png',
}
// website used https://icons8.com/icons
